@if (loading() === false) {
  <glxy-uploader
    #glxyUploader
    class="file-uploader"
    [layout]="'horizontal'"
    [maxFileSize]="TEN_MB"
    [maxFiles]="10"
    [numParallel]="10"
    [autoUpload]="true"
    (fileUploadErrored)="handleFileUploadErrored($event)"
    (fileUploaded)="handleFileUploaded($event)"
  ></glxy-uploader>
} @else {
  <glxy-loading-spinner [fullWidth]="true" [fullHeight]="true"></glxy-loading-spinner>
}
